<section class="entlastungen-page">
  <header class="page-header">
    <div class="page-header-copy">
      <h1>Entlastungen</h1>
      <p>Welche Filialen haben heute bereits Entlastungen erfasst?</p>
    </div>

    <div class="date-badge" aria-label="Heutiges Datum">
      <mat-icon fontSet="material-icons-outlined">calendar_today</mat-icon>
      <span>{{ heuteLabel }}</span>
    </div>
  </header>

  <section class="summary-grid" aria-label="Entlastungen Übersicht">
    @if (isLoading()) {
      @for (_ of skeletonSummaryCards; track $index) {
        <div class="summary-card summary-card-skeleton">
          <span class="skeleton-line skeleton-number"></span>
          <span class="skeleton-line skeleton-label"></span>
        </div>
      }
    } @else {
      <div class="summary-card summary-card-disabled">
        <strong>{{ erfasstCount() }}</strong>
        <span>Erfasst</span>
      </div>

      <div class="summary-card summary-card-disabled">
        <strong>{{ offenCount() }}</strong>
        <span>Ohne Eingabe</span>
      </div>

      <div class="summary-card summary-card-disabled">
        <strong>{{ formatMenge(gesamtMenge()) }}</strong>
        <span>Menge heute</span>
      </div>
    }
  </section>

  <section class="filter-tabs" aria-label="Statusfilter">
    <button
      type="button"
      class="filter-tab"
      [class.filter-tab-active]="isFilterActive('ALLE')"
      (click)="setFilter('ALLE')"
    >
      <span>Alle</span>
      <strong>{{ entries().length }}</strong>
    </button>

    <button
      type="button"
      class="filter-tab"
      [class.filter-tab-active]="isFilterActive('ERFASST')"
      (click)="setFilter('ERFASST')"
    >
      <span>Erfasst</span>
      <strong>{{ erfasstCount() }}</strong>
    </button>

    <button
      type="button"
      class="filter-tab"
      [class.filter-tab-active]="isFilterActive('OFFEN')"
      (click)="setFilter('OFFEN')"
    >
      <span>Ohne Eingabe</span>
      <strong>{{ offenCount() }}</strong>
    </button>
  </section>

  <section class="overview-table" aria-label="Filialen mit Entlastungen">
    <div class="table-scroll">
      <div class="table-header" aria-hidden="true">
        <span>Filiale</span>
        <span>Status</span>
        <span class="numeric">Positionen</span>
        <span class="numeric">Menge</span>
        <span class="action-head">Aktion</span>
      </div>

      <div class="table-body">
        @if (isLoading()) {
          @for (_ of skeletonRows; track $index) {
            <div class="table-row skeleton-row">
              <span class="skeleton-line skeleton-cell-wide"></span>
              <span class="skeleton-line skeleton-cell"></span>
              <span class="skeleton-line skeleton-cell-small"></span>
              <span class="skeleton-line skeleton-cell-small"></span>
              <span class="skeleton-line skeleton-action"></span>
            </div>
          }
        } @else if (filteredEntries().length === 0) {
          <div class="empty-state">Keine Filialen für den gewählten Filter.</div>
        } @else {
          @for (entry of filteredEntries(); track entry.filialNummer) {
            <button
              type="button"
              class="table-row table-row-clickable"
              (click)="openEntlastung(entry)"
            >
              <span class="filiale-cell">
                <strong>{{ entry.filialName }}</strong>
                <small>F{{ entry.filialNummer }}</small>
              </span>

              <span
                class="status-pill"
                [class.status-erfasst]="entry.status === 'Erfasst'"
                [class.status-offen]="entry.status === 'Offen'"
              >
                {{ entry.status === 'Erfasst' ? 'Erfasst' : 'Offen' }}
              </span>

              <span class="numeric value-cell">{{ entry.anzahlPositionen }}</span>
              <span class="numeric value-cell">{{ formatMenge(entry.gesamtMenge) }}</span>

              <span class="edit-button">Bearbeiten</span>
            </button>
          }
        }
      </div>
    </div>
  </section>

  <section class="mobile-list" aria-label="Filialen mit Entlastungen mobil">
    @if (!isLoading() && filteredEntries().length === 0) {
      <div class="empty-state mobile-empty">Keine Filialen für den gewählten Filter.</div>
    }

    @for (entry of filteredEntries(); track entry.filialNummer) {
      <button type="button" class="mobile-card" (click)="openEntlastung(entry)">
        <div class="mobile-filiale">
          <strong>{{ entry.filialName }}</strong>
          <small>F{{ entry.filialNummer }}</small>
        </div>

        <div class="mobile-detail-row">
          <span class="mobile-detail-label">Status</span>
          <span
            class="status-pill"
            [class.status-erfasst]="entry.status === 'Erfasst'"
            [class.status-offen]="entry.status === 'Offen'"
          >
            {{ entry.status === 'Erfasst' ? 'Erfasst' : 'Offen' }}
          </span>
        </div>

        <div class="mobile-detail-row">
          <span class="mobile-detail-label">Positionen</span>
          <strong class="mobile-detail-value">{{ entry.anzahlPositionen }}</strong>
        </div>

        <div class="mobile-detail-row">
          <span class="mobile-detail-label">Menge</span>
          <strong class="mobile-detail-value">{{ formatMenge(entry.gesamtMenge) }}</strong>
        </div>

        <span class="mobile-action">Bearbeiten</span>
      </button>
    }
  </section>
</section>
